/* src/app/private/components/view/roles/create-role/create-role.component.scss */
.selected-backgroud {
  border-radius: 10px !important;
  background-color: var(--p-surface-1200) !important;
}
/*# sourceMappingURL=create-role.component.css.map */
